var _style, _circle, _g, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBank08(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#138F2D;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.7,74.3c-0.5,0-1,0-1.5,0c0-0.4,0-0.7,0-1.1c0-9,0-18.1,0-27.1c0-2.2,0.7-4.1,2-5.7c0.9-1.1,2.1-2.1,3.3-3 c1.4-1,2.8-1.9,4.3-2.8c1.2-0.7,2.4-1.4,3.5-2.2c2.1-1.3,4.2-2.5,5.9-4.3c1.2-1.3,2.3-2.7,2.9-4.5c0,0.2,0,0.4,0,0.6 c0,0.2,0,0.4,0,0.6c0,4.1,0,8.2,0,12.3c0,1.4-0.4,2.7-1.2,3.7c-0.7,1-1.6,1.8-2.5,2.6c-1.1,0.9-2.4,1.7-3.6,2.5 c-2.5,1.6-5,3.2-7.4,4.9c-1.3,0.9-2.6,1.8-3.9,2.9c-1.1,0.9-1.5,2.2-1.6,3.6c-0.1,5.6-0.1,11.2-0.2,16.8 C50.7,74.2,50.7,74.2,50.7,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.5,74.4c-0.6,0-1,0-1.6,0c0-0.2,0-0.5,0-0.7c0-4.3,0-8.6,0-13c0-1.3-0.1-2.5-0.5-3.7 c-0.3-1.1-0.6-2.2-1.3-3c-0.9-1.1-1.8-2.1-2.9-3c-1.1-1-2.3-1.8-3.4-2.7c-1.4-1-2.7-2.1-4.1-3.1c-1.8-1.3-3.4-2.8-4.4-4.8 c-0.6-1.2-1-2.5-1-3.8c0-3.6,0-7.1,0-10.7c0-0.7,0-1.4,0-2.1c0.1,0.2,0.2,0.6,0.4,0.9c0.8,1.6,1.8,3.2,3.2,4.4 c1.8,1.6,3.8,3.2,5.7,4.7c1.7,1.4,3.5,2.8,5.3,4.2c1.2,0.9,2.3,1.8,3.2,3c0.7,1,1.1,2,1.3,3.2c0.3,2,0.2,4,0.2,6 c0,7.8,0,15.6,0,23.3C47.5,73.9,47.5,74.1,47.5,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71,42.1c0,3.4,0.1,7,0,10.5c-0.1,1.4-0.6,2.8-1.7,3.9c-1.2,1.3-2.7,2.2-4.2,3.2c-2,1.3-4,2.6-6,4 c-1.2,0.8-2.3,1.8-3.3,2.9C54.7,67.8,54,69.3,54,71c0,1.1,0,2.2,0,3.4c-0.5,0-1,0-1.6,0c0-0.2,0-0.4,0-0.6c0-4.8,0-9.5,0-14.3 c0-1.6,0.3-3.1,1.3-4.4c0.5-0.7,1.3-1.2,2-1.7c2.1-1.5,4.2-2.9,6.4-4.4c1.3-0.9,2.6-1.6,3.9-2.5c1.3-0.9,2.5-1.8,3.7-2.8 C70.2,43.3,70.6,42.6,71,42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57,79.5c2.3-1.2,4.6-2.3,7.3-2.4c1.9,0,3.6,0.5,5.3,1.4c-2.1-1-4.2-1.2-6.5-1C60.9,77.6,59,78.7,57,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.7,86.5c-4.3,2.1-9.1,1.6-12.1-0.3C47.6,88.1,51.6,88.1,55.7,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.9,80.7c-1,0.2-1.9,0.6-2.9,0.7c-1.9,0.2-3.8-0.1-5.7-0.8c-0.6-0.2-1.3-0.5-1.9-0.8c0-0.1,0-0.1,0.1-0.2 c0.5,0.2,1.1,0.4,1.6,0.6c2,0.8,4,1,6.1,0.9c0.6,0,1.2-0.3,1.8-0.4C53.3,80.7,53.6,80.7,53.9,80.7L53.9,80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.8,72.9c-3.5-0.9-6.8-0.3-10,1.3C60,73,63.5,71.5,67.8,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,82.3c3.4,1.3,6.8,1.4,10.2,0.2C51.3,83.8,47.9,83.9,44.5,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.1,75.6c3-1.1,5.8-0.6,8.6,0.8C66.9,75.3,64.1,74.8,61.1,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.5,80.2c-0.2,0.2-0.4,0.5-0.6,0.6c-1.4,0.6-2.9,1.3-4.4,1.7c-1,0.3-2.2,0.3-3.3,0.4c0,0,0,0,0,0 c0.1-0.1,0.2-0.2,0.4-0.2c0.8-0.1,1.6-0.1,2.4-0.3c0.8-0.2,1.7-0.5,2.5-0.8C56.5,81.2,57.5,80.7,58.5,80.2 C58.5,80.2,58.5,80.2,58.5,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,77.5c-2.7-0.2-5.4,0.1-7.8,1.4C30.8,77.7,35.4,76.9,37.5,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63,81.6c2.8-0.4,5.5,0.2,7.9,1.8C68.3,82.2,65.8,81.4,63,81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.1,75.6c2-0.7,4-0.8,6.6,0c-1.1-0.1-2.2-0.4-3.3-0.4C34.4,75.2,33.2,75.5,32.1,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.2,75c2.2,1,4.5,2,7,1.9C76.9,77.3,73.4,76.5,71.2,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.2,78.8c2.2-0.2,4.3,0.3,6.4,1.2c-0.7-0.2-1.3-0.4-2-0.6c-0.7-0.2-1.4-0.4-2.2-0.4c-0.7-0.1-1.5,0-2.2,0 C34.2,79,34.2,78.9,34.2,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.6,79.2c2.2-0.6,4.3-0.5,6.4,0.3c-1-0.1-2.1-0.4-3.1-0.4C63.8,79,62.7,79.1,61.6,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.4,80.6c2.1-1.1,4.4-1.5,6.7-1C34.8,79.4,32.6,79.6,30.4,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,81.7c1.1,0,2.2,0.3,3.2,0.7c0.9,0.4,1.8,0.8,2.7,1.1c0,0.1,0,0.1-0.1,0.2c-0.4-0.2-0.9-0.4-1.3-0.6 c-1.4-0.6-2.8-1.1-4.3-1.4C37,81.8,37,81.8,36.9,81.7L36.9,81.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.4,83.3c-2.3,0-4.5-0.2-6.7,0.8C61.9,83,64.1,83.1,66.4,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.7,76.3c-1.9-0.8-3.8-1.6-5.9-1.6C66,74.4,68.7,75,70.7,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,78.8c1.7-0.7,3.5-1.3,5.2-2C56.3,77.8,54.6,78.5,52.8,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.1,80.1c-1.8-0.6-3.7-0.6-5.7-0.5C63.4,79.1,66.6,79.3,68.1,80.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.9,77.9c1.6-0.7,3.2-1.3,4.8-2c0,0.1,0.1,0.1,0.1,0.2c-1.6,0.7-3.2,1.3-4.8,2C24.9,78,24.9,77.9,24.9,77.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,76.3c1.5,0.2,2.9-0.1,4.4-0.4c0.2,0,0.4,0,0.5,0c0,0.1,0,0.1,0,0.2c-0.5,0.1-0.9,0.2-1.4,0.3 c-1,0.1-2,0.2-3,0.2C48.9,76.6,48.7,76.4,48.5,76.3L48.5,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.2,73.1c1.8,0,3.3,1,4.9,1.7C40.5,74.2,38.8,73.7,37.2,73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,76.9c-1.8-0.2-3.6,0.2-5.3,0.5C33.3,76.6,35.1,76.7,36.9,76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,78.2c1.6,0.7,3.2,1.4,4.8,2.1c-0.2,0-0.5,0-0.7-0.1c-1.3-0.5-2.5-1.1-3.8-1.6 C41.8,78.5,41.7,78.3,41.6,78.2L41.6,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.7,75.3c-1.3,0.7-2.6,1.4-4.3,1.5C54,76.2,55.4,75.7,56.7,75.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.2,77.6c1.4,0.5,2.8,0.9,4.2,1.4C75.9,79.2,73.1,78.3,72.2,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.2,73.1c1.5,0.2,2.8,1,4.1,1.5c0,0.1,0,0.1-0.1,0.2C41.9,74.2,40.6,73.7,39.2,73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35,72.4c-0.2,0.1-0.4,0.3-0.5,0.3c-1.2-0.1-2.3,0.3-3.4,0.7c-0.2,0.1-0.5,0.1-0.7,0.1c0,0,0,0,0,0 c0.6-0.2,1.1-0.6,1.7-0.7C33.1,72.6,34,72.6,35,72.4L35,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58,78.3c1.4-0.5,2.7-1.3,4.3-1.4c-1.5,0.5-2.8,1-4.2,1.5C58,78.4,58,78.3,58,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.8,78.6c-1.3-0.6-2.6-1.1-3.9-1.7c0-0.1,0.1-0.1,0.1-0.2c1.3,0.6,2.6,1.1,3.9,1.7 C45.8,78.5,45.8,78.6,45.8,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.1,81.8c1.3,0.6,2.6,1.1,3.9,1.7c0,0.1-0.1,0.1-0.1,0.2c-1.3-0.6-2.6-1.1-3.9-1.7 C40,81.9,40.1,81.9,40.1,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.5,79.5c1.4,0.7,2.7,1.3,4.1,2c0,0.1,0,0.1-0.1,0.2c-1.4-0.6-2.8-1.3-4.1-1.9 C68.5,79.6,68.5,79.5,68.5,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.1,80.6c1.3,0.6,2.6,1.1,4,1.7c0,0,0,0.1-0.1,0.1c-1.3-0.5-2.7-1.1-4-1.6C42,80.7,42.1,80.6,42.1,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.3,85.4c-0.6,0.1-1.3,0.2-1.9,0.2c-1,0-1.9,0-2.9,0c0-0.1,0-0.1,0-0.2C49.1,85.5,50.7,85.5,52.3,85.4 L52.3,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,78.2c-0.3,0-0.6-0.1-0.9-0.1c-1-0.3-2.1-0.6-3.1-0.9c-0.1,0-0.2-0.1-0.2-0.1 C38.9,77,40.3,77.6,41.6,78.2C41.6,78.2,41.6,78.2,41.6,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.7,79.6c-1.2-0.6-2.3-1.1-3.5-1.7c0-0.1,0.1-0.1,0.1-0.2c1.1,0.6,2.3,1.1,3.4,1.7 C72.7,79.4,72.7,79.5,72.7,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.2,82.9c-0.2,0.1-0.4,0.2-0.6,0.2c-0.9-0.1-1.9-0.3-2.8-0.5c-0.1,0-0.1-0.1-0.3-0.1c0.2,0,0.3-0.1,0.4,0 c1,0.1,2.1,0.2,3.1,0.4C50,82.8,50.1,82.9,50.2,82.9C50.2,83,50.2,82.9,50.2,82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,81.7c-1.7-0.3-3.3,0.1-5,0.4c1.5-0.6,3.1-0.7,4.7-0.6C36.7,81.6,36.8,81.7,36.9,81.7 C36.9,81.7,36.9,81.7,36.9,81.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.8,80.8c-1.3,0-2.6,0-3.9,0c0,0,0-0.1,0-0.1c1.3,0,2.6,0,3.9,0C51.8,80.7,51.8,80.7,51.8,80.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.6,76.6c-1.2-0.5-2.4-0.9-3.6-1.4C39.4,75.1,40.6,75.5,42.6,76.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.8,74.9c1.1-0.7,2.3-1.2,3.5-1.4C31.2,73.9,30,74.4,28.8,74.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.5,74.3c-0.3,0.2-0.6,0.4-0.9,0.6c-0.8,0.3-1.5,0.6-2.3,0.9c-0.1,0-0.3,0-0.4,0 C26,75.2,27.3,74.8,28.5,74.3C28.5,74.3,28.5,74.3,28.5,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,83.6c1.3,0.1,2.4,0.6,3.5,1.2C40.3,84.3,39.2,83.9,38,83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.9,81.2c0,0.1,0,0.2-0.1,0.2c-1.2,0.4-2.3,0.8-3.5,1.1c0-0.1,0-0.1-0.1-0.2C30.5,82,31.7,81.6,32.9,81.2 L32.9,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.6,73.4c1,0.5,2,1,3,1.5c0.1,0,0.1,0.1,0.1,0.2c0,0,0,0,0,0c-1-0.4-2-0.9-3-1.4 C69.7,73.7,69.6,73.5,69.6,73.4L69.6,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.5,76.8c1.5,0,3,0,4.5,0c0,0,0,0.1,0,0.1c-1.5,0-3,0-4.5,0C47.5,76.9,47.5,76.9,47.5,76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,75.1c1.2-0.2,2.5-0.4,3.7-0.6c0,0,0,0.1,0,0.1c-1.2,0.2-2.4,0.5-3.7,0.7C60.4,75.2,60.4,75.1,60.4,75.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.3,76.6c1-0.3,2.1-0.6,3.1-0.8C25.5,76.3,24.5,76.7,23.3,76.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.2,78.4c-1.2,0.1-2.3-0.3-3.4-0.8c-0.1,0-0.1-0.2-0.2-0.3l0,0C45.8,77.7,47,78.1,48.2,78.4L48.2,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.6,78.1c-1,0.3-2.1,0.6-3.1,0.9c0-0.1,0-0.1-0.1-0.2c1-0.3,2.1-0.6,3.1-0.9C26.6,77.9,26.6,78,26.6,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.8,80.9c1-0.6,2-1.1,3.2-1.2C60.9,80.1,59.9,80.5,58.8,80.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.2,81.1c-0.9,0.1-1.8,0.2-2.7,0.2c-0.2,0-0.4,0-0.6-0.1c0.9-0.1,1.8-0.2,2.6-0.3C64.8,80.9,65,81,65.2,81.1 L65.2,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.4,85.1c1-0.4,1.9-0.7,2.9-1.1c0,0.1,0,0.1,0.1,0.2c-1,0.4-1.9,0.7-2.9,1.1C58.5,85.3,58.5,85.2,58.4,85.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.7,84.5c-0.9-0.3-1.8-0.6-2.7-0.9c1-0.1,1.9,0.4,2.7,0.8C69.7,84.4,69.7,84.4,69.7,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,83.6c-0.9,0.3-1.8,0.5-2.8,0.8c0,0,0-0.1,0-0.1C31.1,84,32,83.4,33,83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.8,87.2c-1-0.3-2.1-0.5-3.1-0.8c0-0.1,0-0.1,0.1-0.2c1,0.3,2,0.6,3.1,0.9C47.8,87.1,47.8,87.1,47.8,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.8,78.4c0.9-0.2,1.7-0.4,2.6-0.7c0,0.1,0,0.1,0,0.2c-0.9,0.2-1.7,0.4-2.6,0.6 C51.8,78.5,51.8,78.4,51.8,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,79.8c-1,0.3-1.9,0.5-2.9,0.8c0,0,0-0.1,0-0.1c1-0.3,1.9-0.6,2.9-0.9C55.3,79.7,55.3,79.7,55.3,79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35,72.4c0.1,0,0.3-0.2,0.4-0.1c0.8,0.1,1.6,0.2,2.4,0.3c0,0.1,0,0.1,0,0.2C36.9,72.7,35.9,72.5,35,72.4 C35,72.4,35,72.4,35,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.4,82.4c-0.8,0.3-1.6,0.7-2.5,1c0-0.1-0.1-0.1-0.1-0.2c0.8-0.3,1.6-0.7,2.5-1 C31.4,82.3,31.4,82.4,31.4,82.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 64.4,
    cy: 76.8,
    rx: 2.4,
    ry: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.3,79.4c-0.8,0.3-1.7,0.6-2.5,0.9c0-0.1,0-0.1-0.1-0.2c0.8-0.3,1.7-0.6,2.5-0.9 C32.2,79.3,32.2,79.3,32.3,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59,82.1c0.8-0.3,1.6-0.5,2.4-0.8c0,0.1,0,0.1,0.1,0.2c-0.8,0.3-1.6,0.5-2.4,0.8C59,82.3,59,82.2,59,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.6,83.3c1.3,0,2.6,0,3.9,0c0,0,0,0.1,0,0.1c-1.3,0-2.6,0-3.9,0C33.6,83.3,33.6,83.3,33.6,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.7,78.4c-1,0.3-1.9-0.2-2.8-0.6C74.9,78,75.8,78.2,76.7,78.4C76.7,78.4,76.7,78.4,76.7,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,85.5c0.4-0.1,0.7-0.3,1.1-0.4c0.5-0.2,1-0.3,1.5-0.4c0,0.1,0,0.1,0,0.2c-0.6,0.2-1.3,0.4-1.9,0.5 C52.8,85.4,52.6,85.4,52.4,85.5C52.3,85.4,52.4,85.5,52.4,85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,76.9c0.7,0.2,1.5,0.4,2.2,0.6c0,0.1,0,0.1,0,0.2c-0.7-0.2-1.5-0.4-2.2-0.6C66.6,77,66.7,76.9,66.7,76.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.9,80.4c-0.7-0.2-1.5-0.4-2.2-0.6c0-0.1,0-0.1,0-0.2c0.7,0.2,1.5,0.4,2.2,0.6 C39.9,80.2,39.9,80.3,39.9,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,74.6c1.3,0,2.6,0,3.9,0c0,0,0,0.1,0,0.1c-1.3,0-2.6,0-3.9,0C33.6,74.7,33.6,74.7,33.5,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.5,73.1c0.7,0.2,1.4,0.4,2.1,0.6c0,0.1,0,0.1,0,0.2c-0.4-0.1-0.7-0.1-1.1-0.2c-0.4-0.1-0.7-0.2-1.1-0.4 C66.4,73.2,66.4,73.1,66.5,73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.8,75.7c0.4-0.2,0.8-0.3,1.2-0.5c0.4-0.2,0.8-0.3,1.2-0.5c0,0.1,0,0.1,0.1,0.2c-0.8,0.3-1.6,0.6-2.4,0.9 C53.9,75.8,53.9,75.8,53.8,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.9,79.3c-0.7,0-1.3,0-2,0c0,0,0-0.1,0-0.1c0.7,0,1.4,0,2,0C50.9,79.2,50.9,79.2,50.9,79.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,87.2c0.9,0,1.8,0,2.7,0c0,0,0,0.1,0,0.1c-0.9,0-1.8,0-2.7,0C48.5,87.2,48.5,87.2,48.5,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.3,84.3c0.7,0.3,1.4,0.5,2.1,0.8c0,0.1-0.1,0.1-0.1,0.2c-0.7-0.3-1.4-0.6-2.1-0.9 C39.3,84.5,39.3,84.4,39.3,84.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.9,81.2c0.8-0.1,1.7-0.2,2.5-0.3C34.6,81.4,33.8,81.3,32.9,81.2C32.9,81.2,32.9,81.2,32.9,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.6,78.7c-0.6,0.3-1.3,0.5-1.9,0.8c0-0.1,0-0.1-0.1-0.2c0.6-0.3,1.3-0.5,1.9-0.8 C28.5,78.6,28.6,78.6,28.6,78.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44,82.2c-0.7-0.3-1.3-0.6-2-0.9c0-0.1,0-0.1,0.1-0.2c0.7,0.3,1.3,0.6,2,0.9C44.1,82.1,44,82.2,44,82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.6,83.8c0.4,0,0.7,0,1.1,0.1c0.3,0.1,0.6,0.2,1,0.3c0,0.1,0,0.1,0,0.2C67,84.2,66.3,84,65.6,83.8 C65.7,83.8,65.6,83.8,65.6,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.8,81.3c-0.7,0-1.3,0-2.1,0C36,80.9,36,80.9,37.8,81.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.6,75c0.6,0.3,1.3,0.5,1.9,0.8c0,0.1-0.1,0.1-0.1,0.2c-0.6-0.3-1.3-0.6-1.9-0.8C42.5,75.1,42.6,75,42.6,75z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.4,85c-0.7-0.1-1.4-0.1-2.1-0.2c0-0.1,0-0.1,0-0.2C47.1,84.6,47.7,84.7,48.4,85C48.4,85,48.4,85,48.4,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,76.3c-0.7-0.1-1.5-0.1-2.2-0.2c0-0.1,0-0.2,0-0.3C47.1,76,47.8,76.2,48.5,76.3 C48.5,76.3,48.5,76.3,48.5,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.7,77.4c0.6-0.3,1.3-0.6,1.9-0.9c0,0.1,0,0.1,0.1,0.2c-0.7,0.3-1.3,0.6-2,0.9 C27.7,77.5,27.7,77.4,27.7,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.6,75.9c-0.7,0.3-1.4,0.6-2.1,0.9c0-0.1,0-0.1-0.1-0.2c0.7-0.3,1.4-0.5,2.1-0.8 C60.6,75.8,60.6,75.8,60.6,75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.1,84.9C51,85,51,85.2,50.9,85.2c-0.7,0-1.4,0-2.2,0c-0.1,0-0.2-0.1-0.3-0.2c0,0,0,0,0,0 C49.3,85,50.2,84.9,51.1,84.9C51.1,84.9,51.1,84.9,51.1,84.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.7,83.8c-0.6,0-1.3,0-1.9,0c0-0.1,0-0.1,0-0.2C64.4,83.7,65,83.4,65.7,83.8C65.6,83.8,65.7,83.8,65.7,83.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.9,80.7c0.6-0.3,1.2-0.6,1.8-0.9c0,0.1,0.1,0.2,0.1,0.2C55.2,80.3,54.6,80.5,53.9,80.7 C53.9,80.7,53.9,80.7,53.9,80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.4,79.2c-0.7-0.1-1.4-0.3-2.1-0.4c0,0,0-0.1,0-0.1c0.7,0.1,1.4,0.2,2.1,0.3C48.4,79,48.4,79.1,48.4,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.7,84c0.5-0.2,1-0.4,1.6-0.6c0,0.1,0.1,0.1,0.1,0.2c-0.5,0.2-1,0.4-1.6,0.6C54.7,84.2,54.7,84.1,54.7,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.7,76.2c0.6,0,1.1,0,1.7,0c0,0,0,0.1,0,0.1C22.8,76.3,22.3,76.3,21.7,76.2C21.7,76.3,21.7,76.2,21.7,76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.5,80.2c0.6-0.2,1.2-0.5,1.9-0.7c0,0.1,0.1,0.2,0.1,0.3C59.8,79.9,59.1,80.1,58.5,80.2 C58.5,80.2,58.5,80.2,58.5,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.3,84.9c-0.5-0.2-1.1-0.4-1.6-0.6c0-0.1,0-0.1,0.1-0.2c0.3,0.1,0.5,0.2,0.8,0.3c0.3,0.1,0.6,0.2,0.8,0.3 C45.3,84.8,45.3,84.8,45.3,84.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.1,83c0.5-0.2,0.9-0.4,1.4-0.6c0,0.1,0.1,0.1,0.1,0.2c-0.5,0.2-0.9,0.4-1.4,0.6 C57.2,83.1,57.1,83.1,57.1,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,74.9c-0.5,0.1-1.1,0.3-1.6,0.4c0-0.1,0-0.1,0-0.2c0.5-0.1,1.1-0.3,1.6-0.4C33,74.8,33,74.9,33,74.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.2,78.4c0.9,0,1.8,0.1,2.8,0.1c0.1,0,0.2,0,0.4,0.1c-1,0-2,0-3,0C48.3,78.6,48.3,78.5,48.2,78.4 C48.2,78.4,48.2,78.4,48.2,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.7,78.6c-0.6-0.2-1.2-0.4-1.8-0.6c0,0,0-0.1,0-0.1c0.6,0.2,1.2,0.4,1.8,0.6C40.7,78.4,40.7,78.5,40.7,78.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40,76c0.5,0.2,1,0.4,1.5,0.6c0,0.1,0,0.1-0.1,0.2c-0.5-0.2-1-0.4-1.5-0.6C39.9,76.1,40,76,40,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.7,73.1c-0.9,0-1.8,0-2.7,0c0,0,0-0.1,0-0.1C34.9,73,35.8,73,36.7,73.1C36.7,73,36.7,73,36.7,73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.6,82.5c0.6-0.2,1.1-0.4,1.7-0.6c0,0.1,0,0.1,0.1,0.2c-0.6,0.2-1.1,0.4-1.7,0.6 C59.6,82.6,59.6,82.6,59.6,82.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.6,83.9c0.1-0.1,0.3-0.2,0.4-0.3c0.4,0,0.8,0,1.2,0c0,0.1,0,0.1,0,0.2C35.7,83.8,35.2,83.8,34.6,83.9 C34.6,83.9,34.6,83.9,34.6,83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.3,73.5c-0.6,0.2-1.1,0.4-1.7,0.6c0,0,0-0.1-0.1-0.1c0.6-0.2,1.1-0.4,1.7-0.6 C61.3,73.4,61.3,73.4,61.3,73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.8,80.2c0.5-0.2,1-0.4,1.5-0.5c0,0,0,0.1,0.1,0.1c-0.5,0.2-1,0.4-1.5,0.6C25.9,80.4,25.8,80.3,25.8,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.1,76.8c-0.5-0.1-0.9-0.2-1.4-0.3c0-0.1,0-0.1,0-0.2c0.5,0.1,0.9,0.2,1.4,0.3 C47.1,76.6,47.1,76.7,47.1,76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.2,82.9c-0.5,0.2-0.9,0.4-1.4,0.6c0,0,0-0.1-0.1-0.1c0.5-0.2,0.9-0.4,1.4-0.7 C59.1,82.8,59.1,82.9,59.2,82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.1,76.9c0.5,0.2,1,0.4,1.4,0.6c0,0.1,0,0.1-0.1,0.2c-0.5-0.2-1-0.4-1.4-0.6C72.1,77,72.1,77,72.1,76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.9,73c-1,0-1.9,0-2.9,0c0,0,0-0.1,0-0.1C64,73,64.9,73,65.9,73C65.9,73,65.9,73,65.9,73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.4,78.1c-0.5,0.1-1,0.2-1.5,0.3c0-0.1,0-0.1,0-0.2c0.5-0.1,1-0.2,1.5-0.4C24.4,78,24.4,78.1,24.4,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,85.6c0.5-0.2,1-0.4,1.4-0.6c0,0.1,0,0.1,0.1,0.2c-0.5,0.2-1,0.4-1.4,0.6C56.1,85.8,56.1,85.7,56,85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.2,74.3c-0.5,0.2-0.9,0.4-1.4,0.6c0-0.1,0-0.1-0.1-0.2c0.4-0.2,0.9-0.4,1.3-0.6 C59.1,74.2,59.2,74.3,59.2,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.4,75.1c0.5,0.2,1,0.4,1.4,0.6c0,0,0,0.1,0,0.1c-0.5-0.2-1-0.3-1.5-0.5C44.4,75.3,44.4,75.2,44.4,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.8,84.1c0.6-0.5,1.2-0.2,1.9-0.2c0,0,0,0,0,0C34,83.9,33.4,84,32.8,84.1L32.8,84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58,85.6c-0.4,0.2-0.8,0.4-1.2,0.6c0-0.1-0.1-0.1-0.1-0.2c0.4-0.2,0.8-0.4,1.2-0.6C58,85.5,58,85.5,58,85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.6,77.4c-0.6,0.2-1.1-0.2-1.5-0.5c0,0,0-0.1,0.1-0.1C43.6,76.9,44.1,77.2,44.6,77.4 C44.6,77.4,44.6,77.4,44.6,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.7,81.9c-0.5,0.2-1,0.4-1.4,0.6c0-0.1,0-0.1-0.1-0.2c0.5-0.2,1-0.4,1.4-0.6C56.6,81.8,56.6,81.9,56.7,81.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.3,73.5c-0.6,0.3-1.2,0.5-1.9,0.8c0,0,0,0,0,0C29.1,74,29.7,73.8,30.3,73.5C30.4,73.5,30.3,73.5,30.3,73.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,82.5c0.4,0.2,0.8,0.4,1.1,0.5c0,0.1,0,0.1-0.1,0.2c-0.4-0.2-0.8-0.3-1.1-0.5 C70.2,82.6,70.3,82.5,70.3,82.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.2,84c-0.4,0-0.8,0-1.2,0c0,0,0-0.1,0-0.1c0.4,0,0.8-0.1,1.2-0.1C63.2,83.8,63.2,83.9,63.2,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.3,86c-0.4-0.2-0.9-0.3-1.3-0.5c0-0.1,0.1-0.1,0.1-0.2c0.4,0.2,0.8,0.4,1.3,0.6C44.4,85.9,44.4,86,44.3,86z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.9,75.5c0.4-0.2,0.9-0.4,1.3-0.6c0,0.1,0,0.1,0.1,0.2c-0.4,0.2-0.9,0.4-1.3,0.6 C27,75.6,26.9,75.6,26.9,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.5,86.5c-0.4,0.1-0.9,0.2-1.3,0.3c0-0.1,0-0.1,0-0.2c0.4-0.1,0.9-0.2,1.3-0.4 C54.5,86.4,54.5,86.4,54.5,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43,79.6c-0.4-0.2-0.8-0.4-1.2-0.6c0-0.1,0-0.1,0.1-0.2c0.4,0.2,0.8,0.4,1.3,0.5C43,79.5,43,79.5,43,79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,84.8c0.4-0.2,0.9-0.4,1.3-0.5c0,0.1,0,0.2,0.1,0.3C53.8,84.6,53.3,84.6,52.8,84.8L52.8,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.6,73.4c-0.5-0.1-0.9-0.1-1.4-0.2c0-0.1,0-0.2,0.1-0.2C68.7,73.2,69.1,73.3,69.6,73.4 C69.6,73.4,69.6,73.4,69.6,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.8,80c0.5-0.2,0.9-0.3,1.4-0.5c0,0.1,0,0.2,0.1,0.2C25.8,79.8,25.3,79.9,24.8,80C24.8,80,24.8,80,24.8,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.8,84c-0.4,0.2-0.8,0.4-1.2,0.5c0-0.1-0.1-0.2-0.1-0.3C31.9,84.2,32.3,84.2,32.8,84 C32.8,84.1,32.8,84,32.8,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,84.7c-0.5,0.4-1.1,0.2-1.7,0.2c0,0,0,0,0,0C51.7,84.9,52.3,84.8,52.8,84.7 C52.8,84.8,52.8,84.7,52.8,84.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.1,81.1c0.5,0,1.1,0.1,1.6,0.1c0,0.1,0,0.1,0,0.2C66.2,81.3,65.7,81.2,65.1,81.1 C65.2,81.1,65.1,81.1,65.1,81.1z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 50,
    cy: 50,
    r: 37.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank08);
export default __webpack_public_path__ + "static/media/icon-bank-08.e705415616f9b6c533c364ed3b377b0f.svg";
export { ForwardRef as ReactComponent };